import config from '../../config/config';
import { map } from 'lodash';

export const VOID_FAILURE = 'VOID/VOID_FAILURE';
export const VOID_LOAD = 'VOID/VOID_LOAD';
export const VOID_SUCCESS = 'VOID/VOID_SUCCESS';

export const VOID_BULK_FAILURE = 'VOID/VOID_BULK_FAILURE';
export const VOID_BULK_LOAD = 'VOID/VOID_BULK_LOAD';
export const VOID_BULK_SUCCESS = 'VOID/VOID_BULK_SUCCESS';

export function voidTransaction(transaction) {
    return {
        failureActionTypeOrCreator: createVoidTransactionFailureActionCreator(transaction.id),
        fetchParams: {
            body: transaction,
            method: 'POST',
            shouldAllowConcurrentFetches: true,
            url: `${config.transactionsApiUrl}/void`
        },
        loadActionTypeOrCreator: createVoidTransactionLoadActionCreator(transaction.id),
        successActionTypeOrCreator: createVoidTransactionSuccessActionCreator(transaction.id)
    };
}

export function createVoidTransactionLoadActionCreator(id) {
    return () => ({
        id,
        type: VOID_LOAD
    });
}

export function createVoidTransactionFailureActionCreator(id) {
    return (error) => ({
        error,
        id,
        type: VOID_FAILURE
    });
}

export function createVoidTransactionSuccessActionCreator(id) {
    return () => ({
        id,
        type: VOID_SUCCESS
    });
}

export function bulkVoidTransactions(transactions) {
    const transactionIds = map(transactions, 'id');

    return {
        failureActionTypeOrCreator: createBulkVoidTransactionFailureActionCreator,
        fetchParams: {
            body: { transactionIds },
            method: 'POST',
            url: `${config.transactionsApiUrl}/void/bulk`
        },
        loadActionTypeOrCreator: VOID_BULK_LOAD,
        successActionTypeOrCreator: createBulkVoidTransactionSuccessActionCreator
    };
}

export function createBulkVoidTransactionFailureActionCreator(error) {
    return {
        error,
        type: VOID_BULK_FAILURE
    };
}

export function createBulkVoidTransactionSuccessActionCreator() {
    return {
        type: VOID_BULK_SUCCESS
    };
}
